import { DataBadge } from 'components/common';
import { Credit, Debit } from 'interfaces';
import { Text, NumberFormatter } from '@mantine/core';

interface PaymentDetailsAccordionProps {
  data: {
    statementCredits: Credit[];
    statementDebits: Debit[];
    overhead: number;
    statementTotalAmount: number;
  };
  credit: Credit;
}

export const PaymentDetailsAccordion: React.FC<
  PaymentDetailsAccordionProps
> = ({ data, credit }) => {
  const isNonOverheadCredit = (credit: Credit): boolean => {
    return (
      credit.description?.includes('deducted') ||
      credit.description?.includes('Interest')
    );
  };
  const net = isNonOverheadCredit(credit)
    ? Number(credit.amount).toFixed(2)
    : Number(data.statementTotalAmount).toFixed(2);
  const overhead = isNonOverheadCredit(credit)
    ? Number('0.00').toFixed(2)
    : (Number(credit.amount) - Number(data.statementTotalAmount)).toFixed(2);
  const gross = Number(credit.amount).toFixed(2);

  return (
    <>
      <Row label="Gross Pay:" value={gross} />
      <Row label="Overhead:" value={overhead} />
      <Row label="Net Pay:" value={net} />
    </>
  );
};

interface RowProps {
  label: string;
  value: string;
}

const Row: React.FC<RowProps> = ({ label, value }) => (
  <Text
    size="sm"
    mb="xs"
    style={{
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
    }}
  >
    {label}{' '}
    <DataBadge>
      <NumberFormatter prefix="$ " value={value} thousandSeparator />
    </DataBadge>
  </Text>
);
